













import { Component, Vue } from 'vue-property-decorator';

interface Sushi {
  delay: number;
  size: number;
}

@Component
export default class SushiPage extends Vue {
  sushis: Sushi[] = [];

  addSushi(): void {
    this.sushis.push({
      delay: Math.random() * 4,
      size: 1 + Math.random() * 4,
    });
  }

  private timer?: any;
  created() {
    this.timer = setInterval(() => {
      this.addSushi();
    }, 1000);
  }

  destroyed() {
    if (this.timer) clearInterval(this.timer);
  }
}
